import { generateActions } from "../utils";

export const GET_USER = generateActions("GET_USER");
export const GET_USER_BY_ID = generateActions("GET_USER_BY_ID");
export const UPDATE_USER = generateActions("UPDATE_USER");
export const UPDATE_PASSWORD = generateActions("UPDATE_PASSWORD");
